import { createAsyncThunk } from "@reduxjs/toolkit";

import { deleteProjectAddon as deleteProjectAddonRequest } from "Api/organizations/projects/deleteProjectAddon.request";

import type { ProjectAddonUpdateResult } from "../types";

export const deleteProjectAddon = createAsyncThunk<
  ProjectAddonUpdateResult,
  {
    organizationId: string;
    projectId: string;
    addonId: string;
  }
>(
  "app/organization/project_addons/delete",
  async ({ organizationId, projectId, addonId }, { rejectWithValue }) => {
    try {
      await deleteProjectAddonRequest({
        organizationId,
        projectId,
        addonId
      });
      return { kind: "remove" as const, addonId };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
